<template>
  <article>
    <section class="news">
      <div class="wrapper">
        <div class="p1-box">
          <div class="detail-title">{{ contentInfoList.imageTitle }}</div>
          <div class="detail-datetime">
            <!--  -->
            <div class="info" style="text-align: right;"><!-- 点击次数：{{ form.clickTotal }} --></div>
          </div>
          <div class="detail-content" v-html="contentInfoList.imageContent"></div>
        </div>
        <div class="infoTime">发表时间：{{ contentInfoList.createDate }}</div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: "NewsRead",
  data() {
    return {
      contentInfoList: []
    }
  },
  created() {
    this.contentInfo()
  },
  methods: {
    contentInfo() {
      this.$http.get("/website/hnWebsiteContentInfo/" + this.$route.params.id, {}, res => {
        if (res.code == '200') {
          this.contentInfoList = res.data
        }
      });
    }
  }
}
</script>

<style scoped>
@import "~@/assets/styles/news.css";

.wrapper {
  width: 940px !important;
}

@media screen and (max-width: 80em) {

  .wrapper {
    width: auto !important;
  }
}

.detail-content {
  line-height: 50px;
}

.infoTime {
  text-align: right;
  margin-bottom: 50px;
  color: #8c8c8c;
}
</style>
